import { useSyncExternalStore } from 'react';

type KbPanelState = {
  isOpen: boolean;
  // Article the panel should open on; undefined shows the tree-only entry.
  slug?: string;
};

let state: KbPanelState = { isOpen: false };

const listeners = new Set<() => void>();

const setState = (next: KbPanelState) => {
  state = next;
  listeners.forEach((listener) => listener());
};

// The agent chat will reuse this entry point to open the panel at an article.
export const openKnowledgeBase = (slug?: string) => {
  setState({ isOpen: true, slug });
};

export const closeKnowledgeBase = () => {
  setState({ isOpen: false });
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

export const useKbPanel = (): KbPanelState & {
  open: typeof openKnowledgeBase;
  close: typeof closeKnowledgeBase;
} => ({
  ...useSyncExternalStore(subscribe, () => state),
  open: openKnowledgeBase,
  close: closeKnowledgeBase,
});
